import { createApp } from 'vue'
import App from 'App.vue'
import axios from 'axios'
import router from 'router'
import store from 'store'
import VueCookies from 'vue3-cookies'
import Toast from "vue-toastification"
import i18n from "i18n.js";
import VueYandexMetrika from 'vue3-yandex-metrika'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import sassStyles from 'scss/main.scss'
import { printDebugConsole } from '@/helpers/debug';

library.add(fas)

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

axios.interceptors.response.use(
    response => {
        // Print debug info in console
        if (response.data && response.data._debug) {
            printDebugConsole(response);
        }

        return response;
    },
    error => Promise.reject(error),
);

const yaMetrikaKey = process.env.VUE_APP_YAMETRIKA_KEY;
const mountEl = document.querySelector("#app");
const app = createApp(App, {
    setup() {
        const {t} = useI18n()
        return {t}
    },
    ...mountEl.dataset
})
app.config.globalProperties.$axios = axios
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)
if(yaMetrikaKey){
    app.use(VueYandexMetrika, {
        id: yaMetrikaKey,
        router: router,
        env: process.env.NODE_ENV
   })
}
app.use(store)
app.use(i18n)
app.use(VueCookies)
app.use(Toast, {
    timeout: 10000,
    position: 'bottom-right',
    transition: "Vue-Toastification__bounce",
    maxToasts: 5,
    // newestOnTop: true,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: false,
    draggable: true,
    draggablePercent: 0.7,
    showCloseButtonOnHover: false,
    //hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
})

app.mount('#app')
